import React, { useMemo } from "react";
import {
  addMinutes,
  endOfDay,
  format,
  isBefore,
  parseISO,
  startOfDay
} from "date-fns";

import Select from "../select";

const DateTimeSelect = React.forwardRef(function DateTimeSelect({
  date,
  placeholder,
  time,
  format: formatProp = "hh:mm aa",
  ...props
}) {
  const times = useMemo(() => {
    if (!date) {
      return [];
    }

    const dayStart = startOfDay(parseISO(date));
    const dayEnd = endOfDay(parseISO(date));
    const slots = [];

    let nextSlot = dayStart;

    while (isBefore(nextSlot, dayEnd)) {
      slots.push({
        time: nextSlot
      });

      nextSlot = addMinutes(nextSlot, 30);
    }

    return slots;
  }, [date]);

  return (
    <Select placeholder={placeholder} value={time} {...props}>
      <option value="" disabled selected>
        {placeholder}
      </option>
      {times?.map(({ time }) => (
        <option key={time} value={format(time, formatProp)}>
          {format(time, formatProp)}
        </option>
      ))}
    </Select>
  );
});

export default DateTimeSelect;
